// Frontend feature flags. Values are read from build-time env (CRA inlines
// process.env.REACT_APP_* at build). Since 2026-07-13 the wave flags default
// ON (Marin: everything visible on staging); setting the env var to the
// literal string "false" is the explicit kill-switch per flag.

// Players | Staff switch on My Players (TP-MyStaff, P1). Default ON.
export const MYSTAFF_ENABLED =
  process.env.REACT_APP_MYSTAFF_ENABLED !== "false";

// "View as" role preview (TP-View-As, superuser-only QA tool). Unlike the
// wave flags above this one defaults OFF — it must be explicitly enabled
// per environment (staging ON / production OFF is Marin's call). The real
// gate is the backend's IsSuperuser 403; this flag is UX only.
export const IMPERSONATION_ENABLED =
  process.env.REACT_APP_IMPERSONATION_ENABLED === "true";

// Agency-side coach/staff mandates (TP-Coach-Mandate). Deliberately the
// Default ON since 2026-07-21 (Marin: show it on staging, precedent PR #88);
// same polarity as MYSTAFF_ENABLED — set the env var to the literal string
// "false" for an explicit per-environment kill-switch.
export const STAFF_MANDATE_ENABLED =
  process.env.REACT_APP_STAFF_MANDATE_ENABLED !== "false";
